import { render, staticRenderFns } from "./ProfileChangeRankinsPageSize.vue?vue&type=template&id=eb93e288&scoped=true"
import script from "./ProfileChangeRankinsPageSize.vue?vue&type=script&lang=js"
export * from "./ProfileChangeRankinsPageSize.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeRankinsPageSize.vue?vue&type=style&index=0&id=eb93e288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb93e288",
  null
  
)

export default component.exports